import appEvent from "../../views/appSettings/event.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("event", {
    url: "event/:id",
    parent: "app",
    views: {
      view: {
        template: appEvent,
      },
    },
    reloadOnSearch: false,
    data: { title: "Event" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/event/event.urls.js